import { useSiteDataQuery } from '../gen/sitedata'
import type { SiteDataQuery } from '../gen/sitedata'
import { useIsLoggedInQuery } from 'auth/hooks'
import { Source } from 'codegen/types'

export function useStudioSiteDataQuery<D = SiteDataQuery>(options?: {
  enabled?: boolean
  select?: (data: SiteDataQuery) => D
}) {
  const isLoggedInQuery = useIsLoggedInQuery()

  return useSiteDataQuery(
    { source: Source.Studio },
    {
      ...options,
      enabled: options?.enabled ?? Boolean(isLoggedInQuery.data),
    },
  )
}
